import { Popup, ScrollView, SelectBox, TextBox } from "devextreme-react";
import Button from "devextreme-react/button";
import {
  Column,
  DataGrid,
  Item as DataGridItem,
  FilterRow,
  Toolbar,
} from "devextreme-react/data-grid";
import {
  ButtonItem,
  Form,
  FormRef,
  GroupItem,
  Item,
} from "devextreme-react/form";
import notify from "../../lib/notify";
import { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { fetchSubordinateEmployees } from "../../api/calendarData";
import {
  downloadEvaluationEmployees,
  downloadEvaluationEmployeesHR,
  downloadEvaluationEmployeesManager,
  downloadSchemaNamne,
  sendEmployeeEvaluation,
  updateEmployeeEvaluation,
  updateEmployeeEvaluationManager,
} from "../../api/employeeEvaluation";
import { useAuth } from "../../contexts/auth";
import { useCompanyContext } from "../../contexts/company";
import { RoleEnum } from "../../types";
import { useScreenSize } from "../../utils/media-query";
import "./Rate.scss";

export const Rate = () => {
  const { t } = useTranslation();
  const { isXSmall, isSmall } = useScreenSize();
  const isMobile = isXSmall || isSmall;
  const [filter, setFilter] = useState("");
  const [viewMode, setViewMode] = useState("Evaluation");
  const employeeAddFormRef = useRef<FormRef | null>(null);
  const managerRatingFormRef = useRef<FormRef | null>(null);
  const selfAssessmentFormRef = useRef<FormRef | null>(null);
  const [schema, setSchema] = useState<any[]>([]);
  const [popupVisibleAnswer, setPopupVisibleAnswer] = useState(false);
  const [schemaName, setSchemaName] = useState<string>("");
  const [schemaNameChoice, setSchemaNameChoice] = useState<
    { id: number; name: string }[]
  >([]);
  const [schemaIdSend, setSchemaIdSend] = useState<number>();
  const [scales, setScales] = useState<number>(0);
  const [selectedMethod, setSelectedMethod] = useState<string>("");
  const [gradingMethod, setGradingMethod] = useState<string>("");
  const [schemaId, setSchemaId] = useState<number>(0);
  const [deadline, setDeadline] = useState<Date | null>(null);
  const today = new Date();
  const nextMonth = new Date();
  nextMonth.setMonth(today.getMonth() + 1);
  const isDeadlineExpired = deadline ? deadline < today : false;
  const [selectedDate, setSelectedDate] = useState<Date>(today);
  const [selectedEndDate, setSelectedEndDate] = useState<Date>(nextMonth);
  const [deadLineDate, setDeadLineDate] = useState<Date>(nextMonth);
  const [showSendButton, setShowSendButton] = useState(false);
  const [showSendButtonSecound, setShowSendButtonSecound] = useState(false);
  const [timeSlots, setTimeSlots] = useState<any[]>([]);
  const { user } = useAuth();
  const role = user?.roles;
  const isNotEmployee = role && !role.includes(RoleEnum.Pracownik);
  const isEmployee = role && role.includes(RoleEnum.Pracownik);
  const isManager = role && role.includes(RoleEnum.Kierownik);
  const isManagerManager = role && role.includes(RoleEnum.Manager);
  const [popupVisibleAdd, setPopupVisibleAdd] = useState(false);
  const [answerPopupVisable, setAnswerPopupVisable] = useState(false);
  const { companyId } = useCompanyContext();
  const isTimeManager = user?.isTimeManager;
  const [userSend, setUserSend] = useState<number[]>([]);
  const [userSendCompanyId, setUserSendCompanyId] = useState<number[]>([]);
  const hasUnansweredSelf = timeSlots.some(
    (slot) => slot.selfAssessment == null
  );
  const hasUnansweredManager = timeSlots.some(
    (slot) => slot.managerRating == null
  );
  const ratingOptions = useMemo(
    () => [
      { value: 20, label: t("rate.veryBad") },
      { value: 40, label: t("rate.bad") },
      { value: 60, label: t("rate.average") },
      { value: 80, label: t("rate.good") },
      { value: 100, label: t("rate.veryGood") },
    ],
    [t]
  );
  const [users, setUsers] = useState<any[]>([]);
  const [employee, setEmployee] = useState<{
    firstName: string;
    lastName: string;
  }>();

  useEffect(() => {
    if (answerPopupVisable) {
      const allAnswered = timeSlots.every(
        (slot) =>
          slot.managerRating !== null && slot.managerRating !== undefined
      );
      setShowSendButton(allAnswered && !isDeadlineExpired);
    }
    if (popupVisibleAnswer) {
      const allAnswered = timeSlots.every(
        (slot) =>
          slot.selfAssessment !== null && slot.selfAssessment !== undefined
      );
      setShowSendButtonSecound(allAnswered && !isDeadlineExpired);
    }
  }, [answerPopupVisable, popupVisibleAnswer, timeSlots, isDeadlineExpired]);

  useEffect(() => {
    if (isNotEmployee) {
      fetchDataForSubordinateEmployess();
    }
  }, [companyId]);

  useEffect(() => {
    FetchEvaluationEmployee();
  }, []);

  useEffect(() => {
    if (viewMode === "EmployeeEvaluation") {
      if (isManager || isManagerManager || isEmployee) {
        FetchEvaluationEmployeesManager();
      } else {
        FetchEvaluationEmployeesHR();
      }
    } else {
      FetchEvaluationEmployee();
    }
  }, [viewMode]);

  const FetchEvaluationEmployee = async () => {
    try {
      const response = await downloadEvaluationEmployees();
      if (response.isOk) {
        setSchema(response.data);
      } else {
        notify(t("An error occurred while processing your request.", "error"));
      }
    } catch (error) {
      notify(`${t("Error:")} ${error || t("Unknown error")}`, "error");
    }
  };

  const toIsoDate = (d: Date) =>
    `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
      d.getDate(),
    ).padStart(2, "0")}`;

  const FetchEvaluationEmployeesHR = async () => {
    try {
      const company = companyId || user?.companyId || 0;
      const response = await downloadEvaluationEmployeesHR(
        company,
        toIsoDate(selectedDate),
        toIsoDate(selectedEndDate),
      );
      if (response.isOk) {
        setSchema(response.data);
      } else {
        notify(t("An error occurred while processing your request.", "error"));
      }
    } catch (error) {
      notify(`${t("Error:")} ${error || t("Unknown error")}`, "error");
    }
  };

  const FetchEvaluationEmployeesManager = async () => {
    try {
      const response = await downloadEvaluationEmployeesManager(
        toIsoDate(selectedDate),
        toIsoDate(selectedEndDate),
      );
      if (response.isOk) {
        setSchema(response.data);
      } else {
        notify(t("An error occurred while processing your request.", "error"));
      }
    } catch (error) {
      notify(`${t("Error:")} ${error || t("Unknown error")}`, "error");
    }
  };

  const FetchSchemaName = async () => {
    try {
      const response = await downloadSchemaNamne();
      if (response.isOk) {
        setSchemaNameChoice(response.data);
      } else {
        notify(t("An error occurred while processing your request.", "error"));
      }
    } catch (error) {
      notify(`${t("Error:")} ${error || t("Unknown error")}`, "error");
    }
  };

  const fetchDataForSubordinateEmployess = async () => {
    try {
      let company = 0;
      if (companyId === 0) {
        company = user?.companyId || 0;
      } else {
        company = companyId;
      }
      const toIso = (d: Date) =>
        `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
          d.getDate(),
        ).padStart(2, "0")}`;
      const response = await fetchSubordinateEmployees(
        company,
        user?.employeeId || 0,
        true,
        toIso(selectedDate),
        toIso(selectedEndDate),
      );
      if (response.isOk) {
        setUsers(response.data);
      } else {
        const usersList = response.data.data || response.data || [];
        setUsers(usersList);
      }
    } catch (err) {
      notify(`${t("Error:")} ${err || t("Unknown error")}`, "error");
    }
  };

  const addAnswer = async () => {
    try {
      const id = timeSlots.map((slot) => slot.id);
      const points = timeSlots.map((slot) => slot.selfAssessment);
      const response = await updateEmployeeEvaluation(id, points);
      if (response.isOk) {
        notify(t("Schema has been successfully saved."), "success");
        FetchEvaluationEmployee();
      } else {
        notify(
          `${t("Error:")} ${response.error || t("Unknown error")}`,
          "error"
        );
      }
    } catch (error) {
      notify(`${t("Error:")} ${error || t("Unknown error")}`, "error");
    }
  };

  const addManagerAnswer = async () => {
    try {
      const id = timeSlots.map((slot) => slot.id);
      const points = timeSlots.map((slot) => slot.managerRating);
      const response = await updateEmployeeEvaluationManager(id, points);
      if (response.isOk) {
        notify(t("Schema has been successfully saved."), "success");
        if (isManager || isManagerManager) {
          FetchEvaluationEmployeesManager();
          FetchSchemaName();
        } else {
          FetchEvaluationEmployeesHR();
        }
      } else {
        notify(
          `${t("Error:")} ${response.error || t("Unknown error")}`,
          "error"
        );
      }
    } catch (error) {
      notify(`${t("Error:")} ${error || t("Unknown error")}`, "error");
    }
  };

  const addUserToEmployeeEvaluation = async () => {
    try {
      const response = await sendEmployeeEvaluation(
        schemaIdSend!,
        userSend,
        userSendCompanyId,
        selectedDate,
        selectedEndDate,
        deadLineDate
      );
      if (response.isOk) {
        notify(t("Schema has been successfully saved."), "success");
        if (isManager || isManagerManager) {
          FetchEvaluationEmployeesManager();
          FetchSchemaName();
        } else {
          FetchEvaluationEmployeesHR();
          FetchSchemaName();
        }
      } else {
        notify(
          `${t("Error:")} ${response.error || t("Unknown error")}`,
          "error"
        );
      }
    } catch (error) {
      notify(`${t("Error:")} ${error || t("Unknown error")}`, "error");
    }
  };

  const togglePopup = (data) => {
    setSchemaId(data.id);
    setDeadline(data?.deadline ? new Date(data.deadline) : null);
    setSchemaName(data.name);
    setScales(data.sumScales);
    setSelectedMethod(data.gradingMethod);
    setTimeSlots(
      (data.elements ?? []).map((el) => ({
        positionName: el.positionName,
        details: el.details,
        scales: el.scales ?? 0,
        id: el.id,
        selfAssessment: el.selfAssessment ?? null,
        managerRating: el.managerRating ?? null,
      }))
    );
    setPopupVisibleAnswer(true);
  };

  const togglePopupAnswer = (data) => {
    setDeadline(data?.deadline ? new Date(data.deadline) : null);
    setGradingMethod(data.gradingMethod);
    setSchemaId(data.id);
    setSchemaName(data.name);
    setScales(data.sumScales);
    setSelectedMethod(data.gradingMethod);
    setEmployee({
      firstName: data.employeeName ?? "",
      lastName: data.employeeLastName ?? "",
    });
    setTimeSlots(
      (data.elements ?? []).map((el) => ({
        positionName: el.positionName,
        details: el.details,
        scales: el.scales ?? 0,
        id: el.id,
        selfAssessment: el.selfAssessment ?? null,
        managerRating: el.managerRating ?? null,
      }))
    );
    setAnswerPopupVisable(true);
  };

  const addPopup = () => {
    fetchDataForSubordinateEmployess();
    FetchSchemaName();
    setPopupVisibleAdd(true);
  };

  const formatDate = (d: any) => {
    if (!d) return "—";
    const date = new Date(d);
    if (isNaN(date.getTime())) return "—";
    return date.toLocaleDateString("pl-PL");
  };

  const filteredSchema = useMemo(() => {
    const q = filter.trim().toLowerCase();
    if (!q) return schema;
    return schema.filter((row: any) => {
      const name = (row?.name ?? "").toLowerCase();
      const fullName =
        `${row?.employeeLastName ?? ""} ${row?.employeeName ?? ""}`
          .trim()
          .toLowerCase();
      return name.includes(q) || fullName.includes(q);
    });
  }, [schema, filter]);

  return (
    <ScrollView useNative>
      <div className="p-6">
        <div className="mb-1 flex flex-col md:flex-row gap-2 justify-between items-start">
          <div>
            <div className="mb-2 text-2xl font-bold leading-none">
              {t("rate.evaluation")}
            </div>
            <div className="text-base">{t("rate.headerText")}</div>
          </div>
          {isNotEmployee || isTimeManager ? (
            <SelectBox
              width={220}
              items={[
                { value: "Evaluation", text: t("rate.myEvaluation") },
                {
                  value: "EmployeeEvaluation",
                  text: t("rate.employeeEvaluation"),
                },
              ]}
              value={viewMode}
              displayExpr="text"
              valueExpr="value"
              onValueChanged={(e) => setViewMode(e.value)}
              placeholder="Choose view"
              labelMode="static"
              label={t("view")}
            />
          ) : null}
        </div>

        {viewMode === "Evaluation" &&
          (isMobile ? (
            <div className="rate-mobile">
              <div className="rate-mobile-filter">
                <TextBox
                  value={filter}
                  onValueChanged={(e) => setFilter(e.value ?? "")}
                  placeholder={t("rate.Search...")}
                  showClearButton
                />
              </div>
              <div className="rate-mobile-list">
                {filteredSchema.length === 0 ? (
                  <div className="rate-mobile-empty">{t("No data")}</div>
                ) : (
                  filteredSchema.map((row: any) => {
                    const disabled = row.isRegistered;
                    return (
                      <div key={row.id} className="rate-mobile-card">
                        <div className="rate-mobile-card-main">
                          <div className="rate-mobile-card-name">
                            {row.name}
                          </div>
                          <div className="rate-mobile-card-meta">
                            {row.gradingMethod && (
                              <span>{row.gradingMethod}</span>
                            )}
                            <span>
                              {t("rate.sumScales")}: {row.sumScales}
                            </span>
                          </div>
                          <div className="rate-mobile-card-meta">
                            <span>
                              {formatDate(row.from)} – {formatDate(row.to)}
                            </span>
                            <span>
                              {t("rate.deadline")}: {formatDate(row.deadline)}
                            </span>
                          </div>
                          {row.rate != null && row.rate !== "" && (
                            <div className="rate-mobile-card-rates">
                              <span>
                                <b>{t("rate.selfAssessment")}:</b> {row.rate}
                              </span>
                            </div>
                          )}
                        </div>
                        <div className="rate-mobile-card-actions">
                          <Button
                            icon="edit"
                            stylingMode="text"
                            disabled={disabled}
                            hint={t("rate.answer")}
                            onClick={() => {
                              if (!disabled) togglePopup(row);
                            }}
                          />
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            </div>
          ) : (
            <DataGrid
              dataSource={schema}
              keyExpr="id"
              showBorders
              allowColumnResizing
              allowColumnReordering
              columnAutoWidth
              searchPanel={{
                visible: true,
                placeholder: t("rate.Search..."),
              }}
              paging={{ pageSize: 10 }}
              pager={{
                visible: true,
                showInfo: true,
                showNavigationButtons: true,
              }}
            >
              <Toolbar>
                <DataGridItem
                  name="searchPanel"
                  location="before"
                  cssClass="datagrid-search-panel-without-margin-left"
                />
              </Toolbar>
              <FilterRow visible />
              <Column
                dataField="name"
                dataType="string"
                caption={t("rate.name")}
              />
              <Column
                dataField="sumScales"
                dataType="string"
                caption={t("rate.sumScales")}
              />
              <Column
                dataField="gradingMethod"
                dataType="string"
                caption={t("rate.gradingMethod")}
              />
              <Column
                dataField="from"
                dataType="datetime"
                caption={t("rate.from")}
                format="dd.MM.yyyy"
              />
              <Column
                dataField="to"
                dataType="datetime"
                caption={t("rate.to")}
                format="dd.MM.yyyy"
              />
              <Column
                dataField="deadline"
                dataType="datetime"
                caption={t("rate.deadline")}
                format="dd.MM.yyyy"
              />
              <Column
                dataField="rate"
                dataType="string"
                caption={t("rate.selfAssessment")}
              />
              <Column
                type="buttons"
                caption={t("rate.actions")}
                buttons={[
                  {
                    icon: "edit",
                    onClick: (e) => {
                      if (e.row && !e.row.data.isRegistered) {
                        togglePopup(e.row.data);
                      }
                    },
                    disabled: (e) => (e.row ? e.row.data.isRegistered : true),
                    hint: t("rate.answer"),
                  },
                ]}
              />
            </DataGrid>
          ))}

        {viewMode === "EmployeeEvaluation" &&
          (isMobile ? (
            <div className="rate-mobile">
              <div className="rate-mobile-filter">
                <TextBox
                  value={filter}
                  onValueChanged={(e) => setFilter(e.value ?? "")}
                  placeholder={t("rate.Search...")}
                  showClearButton
                />
              </div>
              <div className="rate-mobile-list">
                {filteredSchema.length === 0 ? (
                  <div className="rate-mobile-empty">{t("No data")}</div>
                ) : (
                  filteredSchema.map((row: any) => {
                    const disabled = row.isRegistered;
                    const employeeName = `${row.employeeLastName ?? ""} ${
                      row.employeeName ?? ""
                    }`.trim();
                    return (
                      <div key={row.id} className="rate-mobile-card">
                        <div className="rate-mobile-card-main">
                          <div className="rate-mobile-card-name">
                            {employeeName || "—"}
                          </div>
                          {row.name && (
                            <div className="rate-mobile-card-sub">
                              {row.name}
                            </div>
                          )}
                          <div className="rate-mobile-card-meta">
                            {row.gradingMethod && (
                              <span>{row.gradingMethod}</span>
                            )}
                            <span>
                              {t("rate.sumScales")}: {row.sumScales}
                            </span>
                          </div>
                          <div className="rate-mobile-card-meta">
                            <span>
                              {formatDate(row.from)} – {formatDate(row.to)}
                            </span>
                            <span>
                              {t("rate.deadline")}: {formatDate(row.deadline)}
                            </span>
                          </div>
                          <div className="rate-mobile-card-rates">
                            <span>
                              <b>{t("rate.selfAssessmentEmployee")}:</b>{" "}
                              {row.rate ?? "—"}
                            </span>
                            <span>
                              <b>{t("rate.managerRating")}:</b>{" "}
                              {row.managerRate ?? "—"}
                            </span>
                          </div>
                        </div>
                        <div className="rate-mobile-card-actions">
                          <Button
                            icon="edit"
                            stylingMode="text"
                            disabled={disabled}
                            hint={t("rate.answer")}
                            onClick={() => {
                              if (!disabled) togglePopupAnswer(row);
                            }}
                          />
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
              <button
                type="button"
                className="rate-mobile-fab"
                aria-label={t("rate.addEmployee")}
                onClick={addPopup}
              >
                +
              </button>
            </div>
          ) : (
            <DataGrid
              dataSource={schema}
              keyExpr="id"
              showBorders
              allowColumnResizing
              allowColumnReordering
              columnAutoWidth
              searchPanel={{
                visible: true,
                placeholder: t("rate.Search..."),
              }}
              paging={{ pageSize: 10 }}
              pager={{
                visible: true,
                showInfo: true,
                showNavigationButtons: true,
              }}
            >
              <Toolbar>
                <DataGridItem
                  name="searchPanel"
                  location="before"
                  locateInMenu="auto"
                  cssClass="datagrid-search-panel-without-margin-left"
                />
                <DataGridItem location="after" locateInMenu="auto">
                  <Button
                    onClick={addPopup}
                    text={t("rate.addEmployee")}
                    icon="add"
                  />
                </DataGridItem>
              </Toolbar>
              <FilterRow visible />
              <Column
                dataField="employeeLastName"
                dataType="string"
                caption={t("rate.employeeLastName")}
              />
              <Column
                dataField="employeeName"
                dataType="string"
                caption={t("rate.employeeName")}
              />
              <Column
                dataField="name"
                dataType="string"
                caption={t("rate.name")}
              />
              <Column
                dataField="sumScales"
                dataType="string"
                caption={t("rate.sumScales")}
              />
              <Column
                dataField="gradingMethod"
                dataType="string"
                caption={t("rate.gradingMethod")}
              />
              <Column
                dataField="from"
                dataType="datetime"
                caption={t("rate.from")}
                format="dd.MM.yyyy"
              />
              <Column
                dataField="to"
                dataType="datetime"
                caption={t("rate.to")}
                format="dd.MM.yyyy"
              />
              <Column
                dataField="deadline"
                dataType="datetime"
                caption={t("rate.deadline")}
                format="dd.MM.yyyy"
              />
              <Column
                dataField="rate"
                dataType="string"
                caption={t("rate.selfAssessmentEmployee")}
              />
              <Column
                dataField="managerRate"
                dataType="string"
                caption={t("rate.managerRating")}
              />
              <Column
                type="buttons"
                caption={t("rate.actions")}
                buttons={[
                  {
                    icon: "edit",
                    onClick: (e) => {
                      if (e.row && !e.row.data.isRegistered) {
                        togglePopupAnswer(e.row.data);
                      }
                    },
                    disabled: (e) => (e.row ? e.row.data.isRegistered : true),
                    hint: t("rate.answer"),
                  },
                ]}
              />
            </DataGrid>
          ))}

        <Popup
          wrapperAttr={{ class: "rate-popup" }}
          visible={popupVisibleAnswer}
          onHiding={() => setPopupVisibleAnswer(false)}
          fullScreen={isMobile}
          maxWidth={isMobile ? undefined : 700}
          height={isMobile ? "100%" : "auto"}
          maxHeight={isMobile ? undefined : "80vh"}
          title={t("rate.selfAssessment")}
          deferRendering={false}
          contentRender={() =>
            timeSlots.length > 0 && (
              <Form key={`self-${schemaId}`} ref={selfAssessmentFormRef}>
                <GroupItem caption={t("rate.generalInfo")}>
                  <Item
                    render={() => (
                      <div className="rate-info-row">
                        <span>
                          <b>{t("rate.schemaName")}:</b> {schemaName}
                        </span>
                        <span>
                          <b>{t("rate.scales")}:</b> {scales}
                        </span>
                        <span>
                          <b>{selectedMethod}</b>
                        </span>
                      </div>
                    )}
                  />
                </GroupItem>
                <GroupItem caption={t("rate.questions")} colCount={1}>
                  {timeSlots.map((slot, index) => (
                    <Item
                      key={index}
                      render={() => (
                        <div className="rate-question-card">
                          <div className="rate-question-title">
                            {t("rate.positionName")} {index + 1}
                          </div>
                          <div className="rate-question-line">
                            <b>{t("rate.description")}:</b> {slot.details}
                          </div>
                          <div className="rate-question-row">
                            <span>
                              <b>{t("rate.scales")}:</b> {slot.scales}
                            </span>
                            <SelectBox
                              value={slot.selfAssessment ?? null}
                              width={isMobile ? "100%" : 200}
                              dataSource={ratingOptions}
                              valueExpr="value"
                              displayExpr="label"
                              onValueChanged={(e) => {
                                const newSlots = [...timeSlots];
                                newSlots[index].selfAssessment =
                                  e.value ?? null;
                                setTimeSlots(newSlots);
                              }}
                              placeholder={t("rate.select")}
                            />
                          </div>
                        </div>
                      )}
                    />
                  ))}
                </GroupItem>
                {showSendButtonSecound && (
                  <ButtonItem
                    buttonOptions={{
                      text: t("rate.send"),
                      type: "default",
                      width: isMobile ? "100%" : 140,
                      onClick: () => {
                        const validationResult = selfAssessmentFormRef.current
                          ?.instance()
                          .validate();
                        if (validationResult?.isValid) {
                          addAnswer().then(() => setPopupVisibleAnswer(false));
                        }
                      },
                      disabled: hasUnansweredSelf || isDeadlineExpired,
                    }}
                  />
                )}
              </Form>
            )
          }
          showCloseButton
          dragEnabled={!isMobile}
        />

        <Popup
          wrapperAttr={{ class: "rate-popup" }}
          visible={answerPopupVisable}
          onHiding={() => setAnswerPopupVisable(false)}
          fullScreen={isMobile}
          maxWidth={isMobile ? undefined : 800}
          height={isMobile ? "100%" : "auto"}
          maxHeight={isMobile ? undefined : "80vh"}
          title={t("rate.managerRating")}
          deferRendering={false}
          contentRender={() =>
            timeSlots.length > 0 && (
              <Form key={`mgr-${schemaId}`} ref={managerRatingFormRef}>
                <GroupItem caption={t("rate.generalInfo")} colCount={1}>
                  <Item
                    render={() => (
                      <div className="rate-info-row">
                        <span>
                          <b>{t("rate.employee")}:</b>{" "}
                          {employee
                            ? `${employee.lastName} ${employee.firstName}`
                            : ""}
                        </span>
                        <span>
                          <b>{t("rate.schemaName")}:</b> {schemaName}
                        </span>
                        <span>
                          <b>{t("rate.scales")}:</b> {scales}
                        </span>
                        <span>
                          <b>{selectedMethod}</b>
                        </span>
                      </div>
                    )}
                  />
                </GroupItem>
                <GroupItem caption={t("rate.questions")} colCount={1}>
                  {timeSlots.map((slot, index) => (
                    <Item
                      key={index}
                      render={() => (
                        <div className="rate-question-card">
                          <div className="rate-question-title">
                            {t("rate.positionName")} {index + 1}:{" "}
                            {slot.positionName}
                          </div>
                          <div className="rate-question-line">
                            <b>{t("rate.description")}:</b> {slot.details}
                          </div>
                          <div className="rate-question-line">
                            <b>{t("rate.scales")}:</b> {slot.scales}
                          </div>
                          {!gradingMethod.includes("90") && (
                            <div className="rate-question-line">
                              <b>{t("rate.employeeEvaluation")}:</b>{" "}
                              {ratingOptions.find(
                                (opt) => opt.value === slot.selfAssessment
                              )?.label || "-"}
                            </div>
                          )}
                          <div className="rate-question-row">
                            <b>{t("rate.managerRating")}:</b>
                            <SelectBox
                              value={slot.managerRating ?? null}
                              width={isMobile ? "100%" : 220}
                              dataSource={ratingOptions}
                              valueExpr="value"
                              displayExpr="label"
                              onValueChanged={(e) => {
                                const newSlots = [...timeSlots];
                                newSlots[index].managerRating = e.value ?? null;
                                setTimeSlots(newSlots);
                              }}
                              placeholder={t("rate.selectRating")}
                            />
                          </div>
                        </div>
                      )}
                    />
                  ))}
                </GroupItem>
                {showSendButton && (
                  <ButtonItem
                    buttonOptions={{
                      text: t("rate.send"),
                      type: "default",
                      width: isMobile ? "100%" : undefined,
                      onClick: () => {
                        const validationResult = managerRatingFormRef.current
                          ?.instance()
                          .validate();
                        if (validationResult?.isValid) {
                          addManagerAnswer().then(() =>
                            setAnswerPopupVisable(false)
                          );
                        }
                      },
                      disabled: hasUnansweredManager || isDeadlineExpired,
                    }}
                  />
                )}
              </Form>
            )
          }
          showCloseButton
          dragEnabled={!isMobile}
        />

        <Popup
          wrapperAttr={{ class: "rate-popup" }}
          visible={popupVisibleAdd}
          onHiding={() => setPopupVisibleAdd(false)}
          fullScreen={isMobile}
          width={isMobile ? undefined : 400}
          height={isMobile ? "100%" : "auto"}
          maxHeight={isMobile ? undefined : "80vh"}
          title={t("rate.addEmployee")}
          deferRendering={false}
          showCloseButton
          dragEnabled={!isMobile}
          contentRender={() => (
            <Form ref={employeeAddFormRef}>
              <Item
                dataField={t("rate.employee")}
                editorType="dxTagBox"
                editorOptions={{
                  items: users,
                  showSelectionControls: true,
                  searchEnabled: true,
                  applyValueMode: "useButtons",
                  showClearButton: true,
                  displayExpr: (user) =>
                    user ? `${user.lastName} ${user.firstName}` : "",
                  valueExpr: "id",
                  value: userSend || [],
                  onValueChanged: (e) => {
                    const selectedIds = e.value || [];
                    const arraysEqual = (a: number[], b: number[]) =>
                      a.length === b.length &&
                      a.every((val) => b.includes(val));
                    if (!arraysEqual(selectedIds, userSend)) {
                      setUserSend(selectedIds);
                      const selectedCompanyIds = users
                        .filter((user) => selectedIds.includes(user.id))
                        .map((user) => user?.companyId)
                        .filter((id) => id != null);
                      setUserSendCompanyId(selectedCompanyIds);
                    }
                  },
                  placeholder: t("availabilityPopup.selectEmployee"),
                  dropDownOptions: {
                    showScrollbar: "onHover",
                    hideOnOutsideClick: true,
                  },
                }}
                validationRules={[
                  { type: "required", message: t("sheets.schemaNameRequired") },
                ]}
              />
              <Item
                dataField={t("rate.selectMode")}
                editorType="dxSelectBox"
                editorOptions={{
                  value: schemaIdSend,
                  dataSource: schemaNameChoice.map((item) => ({
                    value: item.id,
                    label: item.name,
                  })),
                  valueExpr: "value",
                  displayExpr: "label",
                  onValueChanged: (e) => setSchemaIdSend(e.value),
                  placeholder: t("rate.selectMethod"),
                }}
                isRequired
              />
              <Item
                dataField={t("availabilityPopup.startDate")}
                editorType="dxDateBox"
                editorOptions={{
                  value: selectedDate,
                  type: "date",
                  onValueChanged: (e) => setSelectedDate(e.value),
                }}
                isRequired
              />
              <Item
                dataField={t("rate.endDateEmployee")}
                editorType="dxDateBox"
                editorOptions={{
                  value: selectedEndDate,
                  type: "date",
                  onValueChanged: (e) => setSelectedEndDate(e.value),
                }}
                isRequired
              />
              <Item
                dataField={t("rate.endDate")}
                editorType="dxDateBox"
                editorOptions={{
                  value: deadLineDate,
                  type: "date",
                  onValueChanged: (e) => setDeadLineDate(e.value),
                }}
                isRequired
              />
              <ButtonItem
                buttonOptions={{
                  text: t("rate.send"),
                  type: "default",
                  width: isMobile ? "100%" : undefined,
                  onClick: () => {
                    const validationResult = employeeAddFormRef.current
                      ?.instance()
                      .validate();
                    if (validationResult?.isValid) {
                      addUserToEmployeeEvaluation().then(() =>
                        setPopupVisibleAdd(false)
                      );
                    }
                  },
                }}
              />
            </Form>
          )}
        />
      </div>
    </ScrollView>
  );
};
